import api from './api';

const vaulttableService = {
  // Get all vaulttables with optional filters
  getAllVaultTables: async (filters = {}) => {
    const params = new URLSearchParams();

    if (filters.vaultsourceid) {
      params.append('vaultsourceid', filters.vaultsourceid);
    }

    if (filters.name) {
      params.append('name', filters.name);
    }

    const queryString = params.toString();
    const url = queryString ? `/vaulttable?${queryString}` : '/vaulttable';

    const response = await api.get(url);
    return response.data;
  },

  // Get a single vaulttable by ID
  getVaultTableById: async (id, vaultsourceid = null) => {
    const response = await api.get(`/vaulttable/${id}`);
    return response.data;
  },

  // Create a new vaulttable
  createVaultTable: async (vaulttableData) => {
    const response = await api.post('/vaulttable', vaulttableData);
    return response.data;
  },

  // Update an existing vaulttable
  updateVaultTable: async (id, vaulttableData) => {
    const response = await api.put(`/vaulttable/${id}`, vaulttableData);
    return response.data;
  },

  // Delete a vaulttable
  deleteVaultTable: async (id, vaultsourceid = null) => {
    const response = await api.delete(`/vaulttable/${id}`);
    return response.data;
  }
};

export default vaulttableService;
